import isArchived from 'archive/isArchived';
import {MODEL_FIELD_DISPLAY_NAME} from 'instruments/equipment/EquipmentConstants';
import {isRequiredLinkTagSchema, RequiredLink, SchemaField} from 'schemas/fields/SchemaFieldConstants';

export interface SchemaInterfaceWithFields {
  id: string;
  name: string;
  archiveRecord: {purpose: string} | null;
  fields: Array<{displayName: string; requiredLinkJson: RequiredLink | null}>;
}

/**
 * Get required link from a tag schema's Model schema field. Primarily used for tag schemas with equipment SSI
 */
export function getModelRequiredLinkFromTagSchema(tagSchema: {
  allFields: Array<SchemaField>;
}): RequiredLink | null {
  const modelField = tagSchema.allFields.find((field) => field.name === MODEL_FIELD_DISPLAY_NAME);
  return modelField?.requiredLink ?? null;
}

export function getModelRequiredLinkFromSchemaInterface(
  schemaInterface: SchemaInterfaceWithFields
): RequiredLink | null {
  const modelField = schemaInterface.fields.find((field) => field.displayName === MODEL_FIELD_DISPLAY_NAME);
  return modelField?.requiredLinkJson ?? null;
}

/**
 * Returns true if the equipment schema's Model field links to an archived schema.
 */
export function hasArchivedModelSchema(tagSchema: {allFields: Array<SchemaField>}): boolean {
  const modelLink = getModelRequiredLinkFromTagSchema(tagSchema);
  return modelLink != null && isRequiredLinkTagSchema(modelLink) && isArchived(modelLink.tagSchema);
}

/**
 * Returns true if the equipment fieldset's Model field links to an archived schema.
 */
export function hasArchivedModelSchemaInSchemaInterface(schemaInterface: SchemaInterfaceWithFields): boolean {
  const modelLink = getModelRequiredLinkFromSchemaInterface(schemaInterface);
  return modelLink != null && isRequiredLinkTagSchema(modelLink) && isArchived(modelLink.tagSchema);
}
